import { forwardRef } from "react";
import classNames from "classnames";
import { Tag } from "antd";
import type { TagProps } from "antd/lib";
import styles from "./styles.module.scss";

type Props = TagProps;

export const DefaultTag = forwardRef<HTMLSpanElement, Props>(({ className, ...props }, ref) => {
  return <Tag ref={ref} className={classNames(styles.tag, className)} {...props} />;
});
